import { Outlet, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import logoImage from "@/assets/logo-corre-digital.png";

export function PublicLayout() {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Header */}
      <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="container flex h-16 items-center justify-between px-4 md:px-6">
          <Link to="/" className="flex items-center gap-2">
            <img src={logoImage} alt="Corre Digital" className="h-8" />
          </Link>
          
          <div className="flex items-center gap-3">
            <Button variant="ghost" asChild>
              <Link to="/aluno/login">Entrar</Link>
            </Button>
            <Button asChild>
              <Link to="/aluno/escolha">Cadastrar</Link>
            </Button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="border-t py-6 bg-muted/30">
        <div className="container px-4 md:px-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2">
              <img src={logoImage} alt="Corre Digital" className="h-6 opacity-70" />
              <span className="text-sm text-muted-foreground">
                © {new Date().getFullYear()} Corre Digital
              </span>
            </div>
            <div className="flex items-center gap-4 text-sm text-muted-foreground">
              <Link to="/aluno/landing" className="hover:text-foreground transition-colors">
                Para Talentos
              </Link>
              <Link to="/empresa/login" className="hover:text-foreground transition-colors">
                Para Empresas
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
